import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import serviceofferimg1 from "../../Assets/Images/serviceWeOfferImg1.png";
import serviceofferimg2 from "../../Assets/Images/serviceWeOfferImg2.png";
import serviceofferimg3 from "../../Assets/Images/serviceWeOfferImg3.png";
const ServicesWeOffer = () => {
  return (
    <div className="container service-we-offer-section">
      <div className="">
        <div className=" d-flex justify-content-between align-items-center service-we-offer-header mt-4">
          <h3>Services We Offer</h3>
          <h6>See All <FaArrowRight/></h6>
        </div>
        <div className="row service-we-offer-card mt-4  ">
          <div className="col-lg-4  service-we-offer-card-content">
            <img
              className="service-we-offer-img"
              src={serviceofferimg1}
              alt=""
            />
            <h6>Third-Party Auditing</h6>
            <p>
             We offer independent and impartial third-party audits to evaluate your organization’s compliance with international standards, ensuring credibility, transparency, and continual improvement.
            </p>
            <a href="/services" style={{textDecoration:"none"}}>
            <span>Read Story <FaArrowRight/></span>
            </a>
          </div>
          <div className="col-lg-4  service-we-offer-card-content">
            <img
              className="service-we-offer-img"
              src={serviceofferimg2}
              alt=""
            />
            <h6>Certifications & Renewals</h6>
            <p>
              Our certification services help organizations achieve ISO compliance across various standards. We also manage timely renewals to maintain your certification validity and trust with clients.
            </p>
             <a href="/services" style={{textDecoration:"none"}}>
            <span>Read Story <FaArrowRight/></span>
            </a>
          </div>
          <div className="col-lg-4  service-we-offer-card-content">
            <img
              className="service-we-offer-img"
              src={serviceofferimg3}
              alt=""
            />
            <h6>Trainings – LA & LI</h6>
            <p>
              Gain industry-recognized skills through our Lead Auditor and Lead Implementer training programs, designed to enhance your expertise in auditing and implementing ISO management systems.
            </p>
            <a href="/services" style={{textDecoration:"none"}}>
            <span>Read Story <FaArrowRight/></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesWeOffer;
